import { useGetComponentStatusForPortalQuery } from '../../__generated__/chirp/com/hubspot/ubb/component/status/service/rpc/UbbComponentStatusServiceAppRpc.hooks';
import { useGetComponentStatusQuery } from '../../__generated__/chirp/com/hubspot/ubb/component/status/service/rpc/UbbComponentStatusServiceExternalRpc.hooks';
import { getHostname } from '../utils/getHostname';
import { isAppAuthHostname } from '../utils/hostnamePattern';
export const useIsComponentEnabled = component => {
  // Check hostname to determine service selection
  const hostname = getHostname();
  const isAppAuth = isAppAuthHostname(hostname); // app*.hubspot.com or app*.hubspotqa.com (includes hublets)

  // For authenticated users: Use app-auth service with portal-specific overrides
  const {
    data: appAuthData
  } = useGetComponentStatusForPortalQuery({
    variables: {
      component
    },
    skip: !isAppAuth // Skip if not app-auth
  });

  // For unauthenticated users: Use external service (global status only)
  const {
    data: externalData
  } = useGetComponentStatusQuery({
    variables: {
      component
    },
    skip: isAppAuth // Skip if app-auth
  });
  const data = isAppAuth ? appAuthData : externalData;
  return (data === null || data === void 0 ? void 0 : data.enabled) !== false;
};